import { render, staticRenderFns } from "./attendees.vue?vue&type=template&id=77508a7c&scoped=true&"
import script from "./attendees.vue?vue&type=script&lang=js&"
export * from "./attendees.vue?vue&type=script&lang=js&"
import style0 from "./attendees.vue?vue&type=style&index=0&id=77508a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77508a7c",
  null
  
)

component.options.__file = "attendees.vue"
export default component.exports